import React from 'react';

import '../styles/TitleAndDescriptionComponent.scss';

export default function TitleAndDescriptionComponent(props) {
    return (
        <div id="title-and-description">
            <h1>{props.title}</h1>
            <p>
                <span>{props.description}</span>
            </p>
        </div>
    );
}
